import {IReg, IUiEnv} from 'lib/commons/registry';
import {DOM, ENodeType, JSX} from "lib/commons/xml/dom";
import "back/wsp/views/views_Perms";
import {IScProtocolExecutor, JScProtocolParams, SCPRTC} from "lib/core/scenariProtocol";
import {findElementWedlet, IElementWedlet, WEDLET} from "back/edit/wed/wedlets/wedlet";
import {XA} from "lib/commons/xml/xAddr";
import {isWedletSingleElt} from "back/edit/wed/wedlets/wedletSingleElt";


/**
 * Protocole scenari pour sélectioner un noeud de l'éditeur
 * Contexte requis : Wedlet dans les ascendants de l'emitter
 *
 * ex : scenari:{"action":"wedFocusNode","selector":"*[xxx]"}
 */
export interface JWedFocusNodeScProtocolParams extends JScProtocolParams {

	action: "wedFocusNode"

	/** Querry selector sur le DOM XML des contenus, depuis la racine */
	selectOnXml?: string
	/** Querry selector sur le DOM XML des contenus, depuis l'élément courant du contexte d'appel */
	selectOnXmlRel?: string
	/** Querry selector sur la structure WED, depuis la racine */
	selectOnWed?: string
	/** Querry selector sur le DOM XML des contenus, depuis l'élément courant du contexte d'appel */
	selectOnWedRel?: string

}

export class WedFocusNodeScProtocolExec<P extends JWedFocusNodeScProtocolParams> implements IScProtocolExecutor<P> {
	async execute(params: P, reg: IReg<IUiEnv>, emitter: Element, ev: Event) {
		const vEltWedlet: IElementWedlet = findElementWedlet(emitter, false);
		if (vEltWedlet) {
			const wedMgr = vEltWedlet.wedlet.wedMgr;
			const docHolder = wedMgr.docHolder;
			if (params.selectOnXmlRel) {
				const node: Node = XA.findDomLast(vEltWedlet.wedlet.wedAnchor, docHolder.getDocument());
				if (node.nodeType === ENodeType.element) {
					let selectedNode: Node = (node as Element).querySelector(params.selectOnXmlRel);
					if (selectedNode) WEDLET.focusWedlet(XA.fromNode(selectedNode), wedMgr);
				}
			} else if (params.selectOnXml) {
				let selectedNode: Node = docHolder.getDocument().querySelector(params.selectOnXml);
				if (selectedNode) WEDLET.focusWedlet(XA.fromNode(selectedNode), wedMgr);
			} else if (params.selectOnWedRel) {
				//const vEltWedlet : IElementWedlet = findWedlet(emitter, false);
				let wedlet = vEltWedlet.wedlet;
				while (wedlet && !isWedletSingleElt(wedlet)) wedlet = wedlet.wedParent;
				if (isWedletSingleElt(wedlet)) {
					let selectedNode: Node = wedlet.element?.querySelector(params.selectOnWedRel);
					const vWdl: IElementWedlet = findElementWedlet(selectedNode, false);
					vWdl.focus();
				}
			} else if (params.selectOnWed) {
				const rootWedlet = wedMgr.rootWedlet;
				if (isWedletSingleElt(rootWedlet)) {
					let selectedNode: Node = rootWedlet.element.querySelector(params.selectOnWed);
					if (selectedNode) WEDLET.focusWedlet(XA.fromNode(selectedNode), wedMgr);
				}
			} else
				WEDLET.focusWedlet(XA.fromNode(vEltWedlet), wedMgr);
		}
	}
}

/**
 * Ajoute les différents exécutors au registre
 * @param reg
 */
export function registerEditProtocolsActions(reg: IReg<any>) {
	reg.addToList(SCPRTC.LIST_EXECUTORS, 'wedFocusNode', 1, new WedFocusNodeScProtocolExec());
}